export const statusConstants = {
  active: 'Active',
  pending: 'Pending',
  stopped: 'Stopped',
  cancelled: 'Cancelled',
  restarted: 'Restarted'
};
